// @ts-nocheck
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Endpoints } from '@brg/api';
import { CardImgInfo, CountryViewCardContainer, FigureWrapper, InfoAuthorLikeWrapper, InfoCardAuthor, InfoCardName, InfoWrapper, StyledImg, MuseumCardLayout } from './styled';
// import { useResizedImage } from '@brg/ui'
import AspectRatio from '../AspectRatio';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { SelectRing } from "../projectCard/projectCardNew";
import styled from "styled-components";
var redirectToCard = function (card) {
    // console.log('redirectToCard', card)
};
var SelectRightWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  z-index: 1;\n"], ["\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  z-index: 1;\n"])));
export var useResizedImage = function (files) {
    var filesSafe = useMemo(function () { return files ? __spreadArray([], files, true) : []; }, [files]);
    var containerRef = useRef(null);
    var _a = useState(), container = _a[0], setContainer = _a[1];
    var pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio;
    var containerWidth = container === null || container === void 0 ? void 0 : container.offsetWidth;
    var targetSize = (containerWidth || 0) * pixelRatio;
    var image = useMemo(function () {
        var sorted = filesSafe.sort(function (a, b) { return a.width - b.width; });
        var resized = sorted.find(function (_a) {
            var width = _a.width;
            return width >= targetSize;
        });
        var original = filesSafe.find(function (_a) {
            var size = _a.size;
            return size === 'original';
        });
        return resized || original;
    }, [targetSize, filesSafe]);
    useEffect(function () {
        if (containerRef.current) {
            setContainer(containerRef.current);
        }
    }, []);
    return [image, containerRef];
};
export var CountryViewCard = memo(function (props) {
    var museumCard = props.museumCard, borderless = props.borderless, disabledInfo = props.disabledInfo, isNoMuseumPage = props.isNoMuseumPage, nohover = props.nohover, onClickHandler = props.onClickHandler, cardId = props.cardId, onImageLoad = props.onImageLoad, arrayId = props.arrayId, selectable = props.selectable, selected = props.selected;
    var images = museumCard.images, cardName = museumCard.name, artist = museumCard.artist;
    var _a = useState(false), isImageOver = _a[0], setIsImageOver = _a[1];
    var cardRef = useRef(null);
    var _b = useResizedImage(images), imageUrl = _b[0], containerRef = _b[1];
    var baseUrl = Endpoints.files;
    var imgUrl = imageUrl ? "".concat(baseUrl, "/").concat(imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) : null;
    var author = artist === null || artist === void 0 ? void 0 : artist.fullName;
    var breakPoint = useMediaQuery().breakPoint;
    var onImageOver = useCallback(function () {
        if (nohover)
            return;
        if (!isImageOver) {
            setIsImageOver(true);
        }
    }, [isImageOver, setIsImageOver]);
    var onImageOut = useCallback(function () {
        if (isImageOver) {
            setIsImageOver(false);
        }
    }, [isImageOver, setIsImageOver]);
    var onNameClick = useCallback(function () {
        redirectToCard(museumCard);
    }, [museumCard]);
    return (React.createElement(CountryViewCardContainer, { isNoMuseumPage: isNoMuseumPage },
        imgUrl && (React.createElement(FigureWrapper, { ref: cardRef, 
            // @ts-ignore
            onClick: function () { return onClickHandler(cardId); }, onMouseOver: onImageOver, onMouseLeave: onImageOut, nohover: nohover, borderless: borderless },
            selectable && React.createElement(SelectRightWrapper, null, React.createElement(SelectRing, { active: selected },
                React.createElement("div", null,
                    React.createElement("svg", { width: '12', height: '10', viewBox: '0 0 12 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
                        React.createElement("path", { d: 'M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966\n    4.02557L1 4.85653Z', fill: '#151514', stroke: '#151514' }))))),
            React.createElement(MuseumCardLayout, { borderless: borderless, ref: containerRef },
                React.createElement(AspectRatio, { ratio: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.ratio) || 1, maxWidth: "100%" },
                    React.createElement(StyledImg, { borderless: borderless, src: imgUrl, alt: '', onLoad: onImageLoad && onImageLoad(arrayId, cardId) })),
                breakPoint !== 'xsm' && (React.createElement(CardImgInfo, null, !!isImageOver && (React.createElement(InfoWrapper, null,
                    React.createElement(InfoCardName
                    //onClick={onNameClick}
                    , null, !!cardName && React.createElement("span", null, cardName)),
                    !disabledInfo && (React.createElement(InfoAuthorLikeWrapper, null,
                        React.createElement(InfoCardAuthor, null, !!author && React.createElement("span", null, author))))))))))),
        breakPoint === 'xsm' && isNoMuseumPage && (React.createElement(InfoAuthorLikeWrapper, null,
            React.createElement(InfoCardName, { onClick: onNameClick, isNoMuseumPage: isNoMuseumPage }, !!cardName && React.createElement("span", null, cardName))))));
});
var templateObject_1;
//# sourceMappingURL=CountryViewCard.js.map// @ts-nocheck
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Endpoints } from '@brg/api';
import { CardImgInfo, CountryViewCardContainer, FigureWrapper, InfoAuthorLikeWrapper, InfoCardAuthor, InfoCardName, InfoWrapper, StyledImg, MuseumCardLayout } from './styled';
// import { useResizedImage } from '@brg/ui'
import AspectRatio from '../AspectRatio';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { SelectRing } from "../projectCard/projectCardNew";
import styled from "styled-components";
var redirectToCard = function (card) {
    // console.log('redirectToCard', card)
};
var SelectRightWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  z-index: 1;\n"], ["\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  z-index: 1;\n"])));
export var useResizedImage = function (files) {
    var filesSafe = useMemo(function () { return files ? __spreadArray([], files, true) : []; }, [files]);
    var containerRef = useRef(null);
    var _a = useState(), container = _a[0], setContainer = _a[1];
    var pixelRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio;
    var containerWidth = container === null || container === void 0 ? void 0 : container.offsetWidth;
    var targetSize = (containerWidth || 0) * pixelRatio;
    var image = useMemo(function () {
        var sorted = filesSafe.sort(function (a, b) { return a.width - b.width; });
        var resized = sorted.find(function (_a) {
            var width = _a.width;
            return width >= targetSize;
        });
        var original = filesSafe.find(function (_a) {
            var size = _a.size;
            return size === 'original';
        });
        return resized || original;
    }, [targetSize, filesSafe]);
    useEffect(function () {
        if (containerRef.current) {
            setContainer(containerRef.current);
        }
    }, []);
    return [image, containerRef];
};
export var CountryViewCard = memo(function (props) {
    var museumCard = props.museumCard, borderless = props.borderless, disabledInfo = props.disabledInfo, isNoMuseumPage = props.isNoMuseumPage, nohover = props.nohover, onClickHandler = props.onClickHandler, cardId = props.cardId, onImageLoad = props.onImageLoad, arrayId = props.arrayId, selectable = props.selectable, selected = props.selected;
    var images = museumCard.images, cardName = museumCard.name, artist = museumCard.artist;
    var _a = useState(false), isImageOver = _a[0], setIsImageOver = _a[1];
    var cardRef = useRef(null);
    var _b = useResizedImage(images), imageUrl = _b[0], containerRef = _b[1];
    var baseUrl = Endpoints.files;
    var imgUrl = imageUrl ? "".concat(baseUrl, "/").concat(imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) : null;
    var author = artist === null || artist === void 0 ? void 0 : artist.fullName;
    var breakPoint = useMediaQuery().breakPoint;
    var onImageOver = useCallback(function () {
        if (nohover)
            return;
        if (!isImageOver) {
            setIsImageOver(true);
        }
    }, [isImageOver, setIsImageOver]);
    var onImageOut = useCallback(function () {
        if (isImageOver) {
            setIsImageOver(false);
        }
    }, [isImageOver, setIsImageOver]);
    var onNameClick = useCallback(function () {
        redirectToCard(museumCard);
    }, [museumCard]);
    return (React.createElement(CountryViewCardContainer, { isNoMuseumPage: isNoMuseumPage },
        imgUrl && (React.createElement(FigureWrapper, { ref: cardRef, 
            // @ts-ignore
            onClick: function () { return onClickHandler(cardId); }, onMouseOver: onImageOver, onMouseLeave: onImageOut, nohover: nohover, borderless: borderless },
            selectable && React.createElement(SelectRightWrapper, null, React.createElement(SelectRing, { active: selected },
                React.createElement("div", null,
                    React.createElement("svg", { width: '12', height: '10', viewBox: '0 0 12 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
                        React.createElement("path", { d: 'M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966\n    4.02557L1 4.85653Z', fill: '#151514', stroke: '#151514' }))))),
            React.createElement(MuseumCardLayout, { borderless: borderless, ref: containerRef },
                React.createElement(AspectRatio, { ratio: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.ratio) || 1, maxWidth: "100%" },
                    React.createElement(StyledImg, { borderless: borderless, src: imgUrl, alt: '', onLoad: onImageLoad && onImageLoad(arrayId, cardId) })),
                breakPoint !== 'xsm' && (React.createElement(CardImgInfo, null, !!isImageOver && (React.createElement(InfoWrapper, null,
                    React.createElement(InfoCardName
                    //onClick={onNameClick}
                    , null, !!cardName && React.createElement("span", null, cardName)),
                    !disabledInfo && (React.createElement(InfoAuthorLikeWrapper, null,
                        React.createElement(InfoCardAuthor, null, !!author && React.createElement("span", null, author))))))))))),
        breakPoint === 'xsm' && isNoMuseumPage && (React.createElement(InfoAuthorLikeWrapper, null,
            React.createElement(InfoCardName, { onClick: onNameClick, isNoMuseumPage: isNoMuseumPage }, !!cardName && React.createElement("span", null, cardName))))));
});
var templateObject_1;
//# sourceMappingURL=CountryViewCard.js.map